import React, { useState } from "react"
import '../styles/Search.css'
import searchIcon from "../images/search-icon.svg"
import clearIcon from "../images/close-icon.svg"

interface SearchProps {
    setSearch: any
}

export default function Search({ setSearch }: SearchProps) {

    const [input, setInput] = useState('')

    function onChange(event: any) {
        const title = event.target.value
        setInput(event.target.value)
        setSearch(title.trim())
    }

    function onClick() {
        setSearch('')
        setInput('')
    }

    return (
        <div className="Search">
            <div className="Search-icon">
                <img src={searchIcon} alt="Search Icon" />
            </div>
            {(input) &&
                <button className="Search-clear-text" onClick={onClick}>
                    <img src={clearIcon} alt="Clear text button" />
                </button>}
            <input type="text" placeholder="ค้นหาชื่อนิสิต/รหัสนิสิต" value={input} onChange={onChange} autoComplete="off"/>

        </div>
    )
}